import commonConstant from '../../common/_commonConstant';

export const getAccountingReports = (state, action) => {
  switch (action.type) {
    case commonConstant.GET_ACCOUNTING_REPORT_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.GET_ACCOUNTING_REPORT_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};

export const exportAccountingReports = (state, action) => {
  switch (action.type) {
    case commonConstant.EXPORT_ACCOUNTING_REPORT_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.EXPORT_ACCOUNTING_REPORT_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};

export const getParkingReport = (state, action) => {
  switch (action.type) {
    case commonConstant.GET_PARKING_REPORT_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.GET_PARKING_REPORT_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};

export const exportOperationReports = (state, action) => {
  switch (action.type) {
    case commonConstant.EXPORT_VEHICLE_MOVEMENT_OPERATION_REPORT_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.EXPORT_VEHICLE_MOVEMENT_OPERATION_REPORT_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.EXPORT_REDEMPTION_OPERATION_REPORT_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.EXPORT_REDEMPTION_OPERATION_REPORT_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.EXPORT_MEMBER_MOVEMENT_OPERATION_REPORT_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.EXPORT_MEMBER_MOVEMENT_OPERATION_REPORT_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};

export const getMembershipReport = (state, action) => {
  switch (action.type) {
    case commonConstant.GET_MEMBERSHIP_REPORT_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.GET_MEMBERSHIP_REPORT_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};
